import styled, { css } from 'styled-components';
import Colours from '/shared/styled/Colours';

interface Props {
  disabled?: boolean;
  $small?: boolean;
  $isErrored?: boolean;
}

function disabledStyle({ disabled = false }: Props) {
  if (disabled) {
    return css`
      opacity: 0.4;
      cursor: not-allowed;
    `;
  }
}

function smallStyle({ $small = false }: Props) {
  if ($small) {
    return css`
      width: 16px;
      height: 16px;

      &::after {
        width: 10px;
        height: 10px;
        margin-top: -5px;
        margin-left: -5px;
      }
    `;
  }
}

function $isErroredStyle({ $isErrored = false }: Props) {
  if ($isErrored) {
    return css`
            border-color: ${Colours.redLight5};
        `;
  }
}

// Note, normally I would use rems everywhere but in this instance it needs to
// be pixel perfect and rems can cause it to alias weirdly and make the button
// part off-centre by a single pixel.

export default styled.input.attrs({ type: 'radio' })<Props>`
  position: relative;
  appearance: none;
  margin: 0;
  width: 26px;
  height: 26px;
  background: transparent;
  border-radius: 50%;
  outline: none !important;
  cursor: pointer;
  border: 1px solid ${Colours.greyLight3};
  transition: 0.2s ease-in-out all;

  &::after {
    content: '';
    position: absolute;
    width: 16px;
    height: 16px;
    background: ${Colours.green};
    top: 50%;
    left: 50%;
    margin-top: -8px;
    margin-left: -8px;
    border-radius: 50%;
    opacity: 0;
    transform: scale(0);
    transition: 0.2s ease-in-out all;
  }

  &:checked {
    &::after {
      opacity: 1;
      transform: scale(1);
    }
  }

  &:focus,
  &:active {
    border-color: ${Colours.green};
    outline: none;
  }
  ${disabledStyle}
  ${smallStyle}
  ${$isErroredStyle}
`;
